import React from "react";
import MyGoalContainer from "./okr/common_okr_components/myGoalContainer.component";
import { hot } from "react-hot-loader/root";
import { okrDetailConstants } from "../constants/okr/okrDetails.constants";
class WsGoalsComp extends React.Component {

  componentDidMount()
  {
    removeLoaderWidget();
  }
  
  render() {
    return (
      <div className="ws-okr-wrapper">
        <MyGoalContainer 
          showFilter= {false}
          showManagerFilter = {false}
          showHideShowOkr= {true}
          onlyShowOverDueFilter= {false}
          isSortingEnable= {false}
          showGoalName= {true}
          showTeamName= {false}
          showUserName= {false}
          type= {okrDetailConstants.PAGE_TYPE_WS_TAB_OKR}
        />
      </div>
    );
  }
}

export default hot(WsGoalsComp);
